import * as React from 'react';

import {
    Container,
    ContainerGutter,
    ContainerPadding,
    Figure,
    TextAlignment
} from '@volkswagen-onehub/components-core';

import {MediaSingleItemModel} from '../../../../generated/core';
import {AuthoringWrapper} from '../../../components/AuthoringWrapper';
import {SimpleDisclaimerWrapper} from '../../../context/layer/SimpleDisclaimerWrapper';
import {MapTo} from '../../../infrastructure/compatibility/MapTo';
import {MediaElement} from '../elements/MediaElement';
import {RichtextSimpleElement} from '../elements/RichtextElement';

/**
 * I106 Media Single Item
 */
export class InternalMediaSingleItem extends React.PureComponent<MediaSingleItemModel> {
    public static RESOURCE_TYPE: string =
        'vwa-ngw18/components/editorial/items/mediaSingleItem';

    // the CSS class of the auto-generated container DIV (usually the component name)
    public static CQ_CONTAINER_CLASS: string = '.mediaSingleItem';

    public render(): JSX.Element {
        const {hasCaptionAboveMedia} = this.props;

        const caption = (
            <Container
                horizontalAlign="center"
                padding={{
                    left: ContainerPadding.dynamic0150,
                    right: ContainerPadding.dynamic0150
                }}
                wrap="always"
            >
                <RichtextSimpleElement
                    path="caption"
                    textAlign={TextAlignment.center}
                />
            </Container>
        );

        const media = (
            <Figure caption={caption} captionAboveMedia={hasCaptionAboveMedia}>
                <MediaElement path="media" />
            </Figure>
        );

        return (
            <AuthoringWrapper
                title="I106 Media Single Item"
                bgColor={AuthoringWrapper.BG_COLOR_ITEM}
            >
                <SimpleDisclaimerWrapper>
                    <Container
                        gutter={ContainerGutter.dynamic0020}
                        stretchContent
                        wrap="always"
                    >
                        {media}
                    </Container>
                </SimpleDisclaimerWrapper>
            </AuthoringWrapper>
        );
    }
}

export const MediaSingleItem = MapTo(
    InternalMediaSingleItem.RESOURCE_TYPE,
    InternalMediaSingleItem
);
